import { React, useEffect, useState } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { useAuth } from '@/contexts'
import Swal from 'sweetalert2'
import { useTranslation } from 'react-i18next'
import { SignInForm } from './components/SignInForm'
import { useFormSignIn } from './hooks'
import { useLoginCustomer } from './hooks/useLoginCustomer'

export const SignIn = () => {
  const [modalIsOpen, setModalIsOpen] = useState(false)
  const { t } = useTranslation()
  const navigate = useNavigate()
  const location = useLocation()
  const { token, setToken } = useAuth()
  const { data, error, loading, login } = useLoginCustomer()

  const {
    handleSubmit: singInHandleSubmit,
    handleChange: singInHandleChange,
    setFieldValue: singInSetFieldValues,
    values: singInValues,
    errors: singInErrors,
  } = useFormSignIn({
    onSubmit: values => {
      login(values)
    },
  })

  useEffect(() => {
    if (token) navigate('/exam')
  }, [token])

  useEffect(() => {
    if (!data) return
    setToken(data.token)
    const from = location.state?.from?.pathname || '/exam'
    navigate(from, { replace: true })
  }, [data])

  useEffect(() => {
    if (!error) return
    Swal.fire({
      title: t('signIn.userOrPasswordInvalid'),
      text: t('signIn.tryAgain'),
      icon: 'error',
      confirmButtonText: 'Ok',
    })
  }, [error])

  const handleModalIsOpen = () => {
    setModalIsOpen(!modalIsOpen)
  }

  return (
    <div className='w-full mb-20 my-10 md:my-20 xl:my-24 grid place-content-center'>
      <div className='flex justify-center px-10 md:px-5'>
        <img src='images/logoBg.png' className='max-w-[12rem] md:max-w-[15rem] w-fit' />
      </div>
      <h2 className='text-center font-semibold text-[20px] lg:text-xl'>Seja bem vindo a central de Laudos!</h2>
      <SignInForm
        loading={loading}
        handleSubmit={singInHandleSubmit}
        handleChange={singInHandleChange}
        setFieldValue={singInSetFieldValues}
        values={singInValues}
        errors={singInErrors}
        handleModalIsOpen={handleModalIsOpen}
      />
    </div>
  )
}
